module.exports = __webpack_public_path__ + "img/1624.68498bbd.gif";